// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Button from "../components/Button/Button.bs.js";
import * as Emotion from "../bindings/Emotion.bs.js";
import * as Typography from "../components/Typography/Typography.bs.js";
import * as AuthContext from "../context/AuthContext.bs.js";
import * as JsxRuntime from "react/jsx-runtime";

function LoginPage(props) {
  let auth = AuthContext.useAuth();
  let containerStyles = Emotion.Css.css({
    padding: "4rem 1rem",
    maxWidth: "400px",
    margin: "0 auto",
    textAlign: "center"
  });
  let cardStyles = Emotion.Css.css({
    borderTop: `2px solid ` + Emotion.Utils.Color.primary,
    padding: "2rem 0",
    marginTop: "2rem"
  });
  let user = auth.state;
  if (typeof user !== "object") {
    return JsxRuntime.jsxs("div", {
      children: [
        JsxRuntime.jsx(Typography.Typography.Display.make, {
          size: "3xl",
          children: "Sign In"
        }),
        JsxRuntime.jsx(Typography.Typography.Body.make, {
          className: Emotion.Css.css({
            marginTop: "1rem",
            color: Emotion.Utils.Color.textSecondary
          }),
          children: "Authenticate using OAuth 2.0 with PKCE."
        }),
        JsxRuntime.jsxs("div", {
          children: [
            JsxRuntime.jsx(Typography.Typography.Body.make, {
              className: Emotion.Css.css({
                marginBottom: "1.5rem",
                color: Emotion.Utils.Color.textSecondary
              }),
              children: "Reading is open. Sign in when you want to write at the desk. The demo mock auto-approves OAuth 2.0 PKCE and returns a sample user."
            }),
            JsxRuntime.jsx(Button.Button.make, {
              variant: "primary",
              fullWidth: true,
              onClick: param => {
                auth.login();
              },
              children: "Sign in with OAuth"
            }),
            JsxRuntime.jsxs(Typography.Typography.Caption.make, {
              className: Emotion.Css.css({
                marginTop: "1.5rem",
                display: "block"
              }),
              children: [
                "Locally this uses ",
                JsxRuntime.jsx("code", {
                  children: "bun run dev:server",
                  className: Emotion.Css.css({
                    fontSize: "0.8125rem",
                    color: Emotion.Utils.Color.primary
                  })
                }),
                ". On Vercel the same mock is hosted next to the app."
              ]
            })
          ],
          className: cardStyles
        })
      ],
      className: containerStyles
    });
  }
  let user$1 = user._0;
  return JsxRuntime.jsxs("div", {
    children: [
      JsxRuntime.jsx(Typography.Typography.Display.make, {
        size: "3xl",
        children: "Welcome back"
      }),
      JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsx(Typography.Typography.Heading.make, {
            level: "h3",
            children: user$1.name
          }),
          JsxRuntime.jsx(Typography.Typography.Body.make, {
            className: Emotion.Css.css({
              color: Emotion.Utils.Color.textSecondary
            }),
            children: user$1.email
          }),
          JsxRuntime.jsx("div", {
            children: JsxRuntime.jsx(Button.Button.make, {
              variant: "outline",
              onClick: param => auth.logout(),
              children: "Sign Out"
            }),
            className: Emotion.Css.css({
              marginTop: "1.5rem"
            })
          })
        ],
        className: cardStyles
      })
    ],
    className: containerStyles
  });
}

let Typography$1;

let Button$1;

let make = LoginPage;

export {
  Typography$1 as Typography,
  Button$1 as Button,
  make,
}
/* Button Not a pure module */
